import React from 'react';

import { Helpers } from '../../core/src/helpers';
import ProductMap from './product-map';
import ProductShow from './product-show';
import ProductShowPlaceholder from './product-show-placeholder';
import ProductFilter from './product-filter';
import ProductResults from './product-results';
import { isDealActive } from './deals';
import SearchResults from '../../search-filter/components/search-results';
import SearchTopBar from '../../search-filter/components/search-top-bar';
import SortDropdown from '../../search-filter/components/sort-dropdown';
import VWAFilterCrumb from '../../vwa/components/vwa-filter-crumbs';

import '../css/product.less';

const { memoize } = Helpers;

export const SORT_TYPES = [
    { label: 'HP recommends', value: 'rank.recommended' },
    { label: 'Best seller', value: 'rank.default' },
    { label: 'Lowest price', value: 'price' },
    { label: 'Highest price', value: '-price' },
    { label: 'Highest discount($)', value: '-discount' },
    { label: 'Highest discount(%)', value: '-percent_discount' },
    { label: 'Name', value: 'name' },
    { label: 'Rating', value: '-rating' }
];

export const getProdHideStatus = (autoHideType, disableAutoHide, prd, params) => {
    const { prdClass } = prd;
    if (prdClass === "USER_DEFINED") {
        return true;
    }

    if (disableAutoHide || (prd.metadata.hasOwnProperty('alwaysShow') && prd.metadata.alwaysShow)) {
        return true;
    }

    const isGiftCard = Helpers.isGiftCard(prd);
    const { prices, deals } = params;
    const prdPrice = Helpers.getProductPrice(prd, prices, false);
    let checker = true;
    //checking Product Stock
    if (prdPrice &&
        prdPrice.stock === 0 &&
        prdClass !== "CTO" &&
        (autoHideType === 'hideOOS' || autoHideType === 'hideNoIROOS' || autoHideType === undefined)
    ) {
        checker = false;
    }
    let hasActiveDeal;
    //If product has a deal
    if (deals.hasOwnProperty(prd.prodId)) {
        hasActiveDeal = isDealActive(deals[prd.prodId]);
    }
    //checking product sale
    if (!isGiftCard &&
        prdPrice &&
        !prdPrice.inCartPrice &&
        !hasActiveDeal &&
        !(prdPrice.salePrice && prdPrice.regularPrice > prdPrice.salePrice) &&
        (autoHideType === 'hideNoIR' || autoHideType === 'hideNoIROOS' || autoHideType === undefined)
    ) {
        checker = false;
    }
    return checker;
}

export class ProductList extends React.PureComponent {
    static whyDidYouRender = true;

    constructor(props) {
        super(props);
        this.changeSort = this.changeSort.bind(this);
        this.tabStyle = {};
        this.productItem = this.productItem.bind(this);
        this.prefetchInterval = null;
    }

    componentDidMount() {
        const { pg, productCat = {}, fetchProducts, prefetchTabs } = this.props;
        if (!productCat.products || productCat.products.length === 0) {
            fetchProducts(pg);
        } else if (prefetchTabs) {
            this.prefetchProduct();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.slug == this.props.slug && this.props.pg && prevProps.pg !== this.props.pg && !this.props.productCat.products.length) {
            prevProps.fetchProducts(this.props.pg);
        } else if (this.props.prefetchTabs) {
            this.prefetchProduct();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.prefetchInterval);
    }

    prefetchProduct = () => {
        const { pg, prefetchProducts } = this.props;
        const [vanityUrl] = pg.split(':')
        //if there are still keys left to fetch, prefetch them
        if (prefetchProducts) {
            this.prefetchInterval = setTimeout(() => prefetchProducts(vanityUrl), 400);
        }
    }

    changeSort(e) {
        this.props.sortProducts(e.target.value, this.props.pg);
        this.props.scrollTop();
    }

    productItem(product, key, enableAppPDP, className, productIndex, placeholder) {
        const {
            addToCart = () => { },
            slugKey,
            pg
        } = this.props;

        const jumpInfo = {
            slugKey,
            pg: pg.split(":").pop()
        }

        //pass in placehodler that has price component so that prices are available earlier and can filter OOS/NO IR
        if (placeholder) {
            return <ProductShowPlaceholder product={product} />
        }

        return (
            <ProductShow
                className={className}
                key={key}
                product={product}
                addToCart={addToCart}
                fetchSpecs={this.fetchTechSpecs}
                jumpInfo={jumpInfo}
                enableAppPDP={enableAppPDP}
                productIndex={productIndex}
            />
        );
    }

    prdFilterCondition = memoize((searchResults, query) => (prd, params) => {
        let { prdClass } = prd;
        const { autoHideType, disableAutoHide } = this.props;
        //if filters are enabled ,ignore auto hide functionality
        if (searchResults && searchResults.length > 0) {
            //only show UDF when search is enabled if not filtering on anything
            if (prdClass === "USER_DEFINED") {
                return Object.keys(query || {}).length === 0;
            }
            return searchResults.indexOf(prd.sku) > -1;
        }
        return getProdHideStatus(autoHideType, disableAutoHide, prd, params);
    })

    render() {
        const {
            fixedHeader,
            productCat,
            enableAppPDP,
        } = this.props;
        const { products } = productCat
        const fixedInfoClassName = fixedHeader ? " fixed-info" : "";
        const shiftProductsClassName = fixedHeader ? " shift-down" : "";

        return (

            <SearchResults>
                {({ results, disableSearch, query, searchInProgress }) => (
                    <ProductFilter products={products} condition={this.prdFilterCondition(!disableSearch && !searchInProgress ? results : null, query)}>
                        {(filteredProducts) => {
                            const productListLength = filteredProducts.filter(p => p.prdClass !== 'USER_DEFINED').length;
                            return (
                                <ProductResults>
                                    <div className={"info-bar clearfix" + fixedInfoClassName}>
                                        <SearchTopBar>
                                            <VWAFilterCrumb hideCategory={true} useAlias={true} />
                                            <div className="num-results">{productListLength > 0 ? `${productListLength} results` : ""}</div>
                                            <SortDropdown
                                                options={SORT_TYPES}
                                                value={productCat.sortValue}
                                                onChange={this.changeSort}
                                            />
                                        </SearchTopBar>
                                    </div>
                                    <div className={"products-list" + shiftProductsClassName}>
                                        <ProductMap
                                            products={filteredProducts}
                                            productItem={this.productItem}
                                            enableAppPDP={enableAppPDP}
                                            customPlaceHolder={true}
                                        />
                                    </div>
                                </ProductResults>);
                         }
                        }
                    </ProductFilter>
                )}
            </SearchResults>
        );
    }
}

ProductList.defaultProps = {
    productCat: { products: [], sortValue: 'rank.recommended' },
    filtersResults: { hits: { hits: null } },
    userInfo: {}
};
